import { io, Socket } from "socket.io-client";

const UPDATE_ATTRIBUTE = "update_attribute";
export type TUpdateAttributeTopic = typeof UPDATE_ATTRIBUTE;
export type TUpdateAttributePayload = {
  type: "control" | "automation" | "device" | "timer" | "scene";
  id: number;
  attribute: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  value: any;
};
type TServerToClientEvents = {
  [UPDATE_ATTRIBUTE]: (payload: TUpdateAttributePayload) => void;
};

const PROCESS_COMMAND = "process_command";
export type TProcessCommandPayload = {
  type: "control" | "device" | "scene";
  id: number;
  command: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  value?: any;
};

type TClientToServerEvents = {
  [PROCESS_COMMAND]: (payload: TProcessCommandPayload) => void;
  [UPDATE_ATTRIBUTE]: (payload: TUpdateAttributePayload) => void;
};

type TSocket = Socket<TServerToClientEvents, TClientToServerEvents>;
type TBroadCastCallback = (
  topic: TUpdateAttributeTopic,
  payload: TUpdateAttributePayload,
) => void;

export class ReconnectingSocket {
  private socket: TSocket | undefined;
  private reconnect_counter: number;

  constructor() {
    this.socket = undefined;
    this.reconnect_counter = 0;
  }

  update_attribute(payload: TUpdateAttributePayload) {
    this.socket?.emit(UPDATE_ATTRIBUTE, payload);
  }

  process_command(payload: TProcessCommandPayload) {
    this.socket?.emit(PROCESS_COMMAND, payload);
  }

  connect(broadCastCallback: TBroadCastCallback) {
    console.log(this.logPrefix() + " CONNECT");
    this.socket = io({
      auth: { access_token: localStorage.getItem("accessToken") },
    });

    this.socket.on("connect", () => {
      console.log(this.logPrefix() + " on connect");
      this.reconnect_counter = 0;
    });

    this.socket.on("disconnect", async (reason, description) => {
      console.log(
        this.logPrefix() + " on disconnect " + reason + ", " + description,
      );
      this.reconnect(broadCastCallback);
    });

    this.socket.on("connect_error", async (error: unknown) => {
      console.log(this.logPrefix() + " on connect_error " + error);
      this.reconnect(broadCastCallback);
    });

    this.socket.on("update_attribute", (payload: TUpdateAttributePayload) => {
      broadCastCallback("update_attribute", payload);
    });
  }

  disconnect() {
    console.log(this.logPrefix() + " DISCONNECT");
    if (this.socket) {
      this.socket.off("connect");
      this.socket.off("disconnect");
      this.socket.off("connect_error");
      this.socket.off("update_attribute");
      this.socket.disconnect();
      this.socket = undefined;
    }
  }

  private reconnect(broadCastCallback: TBroadCastCallback) {
    console.log(
      this.logPrefix() + " RECONNECT, isConnected=" + this.socket?.connected,
    );
    this.disconnect();
    const timeout = this.reconnect_counter * 200;
    setTimeout(() => {
      this.connect(broadCastCallback);
    }, timeout);
    if (this.reconnect_counter < 5) {
      this.reconnect_counter += 1;
    }
  }

  private logPrefix() {
    return "[ReconnectingSocket] (" + (this.socket?.id || "N/A") + ")";
  }
}
